/**
 * <brick-share> — native share sheet on touch devices, clipboard copy
 * elsewhere (status announced via [data-share-status]). Same element as in
 * assets/product.js; whichever loads first defines it.
 */
(() => {
  if (customElements.get('brick-share')) return;

  class BrickShare extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-share]');
      this.status = this.querySelector('[data-share-status]');
      if (this.button) this.button.addEventListener('click', () => this.share());
    }

    async share() {
      const url = this.dataset.url || window.location.href;
      const coarse = window.matchMedia('(pointer: coarse)').matches;
      if (navigator.share && coarse) {
        try {
          await navigator.share({ title: this.dataset.title, url });
          return;
        } catch (error) {
          if (error.name === 'AbortError') return;
        }
      }
      try {
        await navigator.clipboard.writeText(url);
        this.say(this.dataset.textCopied);
      } catch (error) {
        window.prompt('', url);
      }
    }

    say(text) {
      if (!this.status) return;
      this.status.textContent = text;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.status.textContent = '';
      }, 2600);
    }
  }

  customElements.define('brick-share', BrickShare);
})();
